/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });
  //
  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:pagination:done', function (e) {
    const { sectionId } = e.detail;

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const target = document.querySelector('.collection__heading') || section;
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    ) || 0;

    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - headerHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  });


  document.addEventListener('DOMContentLoaded', function () {
    const swatchItems = document.querySelectorAll('.product__color-swatch-item');
    const titleElement = document.querySelector('[data-color-swatch-title]');
    if (swatchItems) {
      const defaultTitle = titleElement ? titleElement.textContent : null;
      const defaultItem = document.querySelector('.product__color-swatch-item.active');
      swatchItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));

          this.classList.add('active');

          const newDescription = this.getAttribute('data-short-description');
          if (newDescription && titleElement) {
            titleElement.textContent = newDescription;
          }
        });
        item.addEventListener('mouseleave', function () {
          swatchItems.forEach((el) => el.classList.remove('active'));
          if (titleElement) {
            titleElement.textContent = defaultTitle;
          }
          if (defaultItem) {
            defaultItem.classList.add('active');
          }
        });
      });
    }

    // Custom scroll behavior
    const elem = document.querySelector('.product__inner');
    if (elem) {
      const pt = window.getComputedStyle(elem, null).getPropertyValue('padding-top');
      const thirdOfNumber = parseInt(pt.replace('px', ''), 10) / 3;
      elem.style.top = `calc(-${pt} + var(--header-height, 47px))`;
    }

    // Vertical dropdown menu 3 level images changing
    const selectors = {
      verticalDropdown: '.header__dropdown.header__dropdown--vertical',
      imagesContainer: '.header__dropdown__right',
      linkItem: '.navlink.navlink--grandchild',
      defaultImage: '[data-connected-link="default"]',
    };

    const verticalDropdowns = document.querySelectorAll(selectors.verticalDropdown);

    const updateVerticalDropdownImage = (container, imageElem) => {

      if (!imageElem || imageElem.classList.contains('block')) return;

      const currentImage = container.querySelector('.block');

      currentImage.classList.add('hidden');
      currentImage.classList.remove('block');

      imageElem.classList.add('block');
      imageElem.classList.remove('hidden');
    };

    verticalDropdowns.forEach((dropdown) => {
      const imagesContainer = dropdown.querySelector(selectors.imagesContainer);

      if (imagesContainer) {
        const defaultImage = imagesContainer.querySelector(selectors.defaultImage);
        dropdown.querySelectorAll(selectors.linkItem).forEach(link => {
          link.addEventListener('mouseenter', ({ target }) => {
            const connectedImage = imagesContainer.querySelector(`[data-connected-link="${target.getAttribute(
                    'href')}"]`);
            if (connectedImage) {
              updateVerticalDropdownImage(imagesContainer, connectedImage);
              return;
            }

            updateVerticalDropdownImage(imagesContainer, defaultImage);
          });
        });
      }
    });
  });

  const collectionDescription = document.querySelector('.collection__heading__description');
  if (!collectionDescription) return;

  const collectionDescriptionText = collectionDescription.querySelector('p');
  if (!collectionDescriptionText) return;

  const desktopLimit = collectionDescription.getAttribute('data-max-chars-desktop') || 200;
  const mobileLimit = collectionDescription.getAttribute('data-max-chars-mobile') || 200;

  const fullText = collectionDescriptionText.innerText.trim();
  const isMobile = window.innerWidth < 768;
  const limit = isMobile ? mobileLimit : desktopLimit;

  if (fullText.length <= limit) {
    collectionDescriptionText.innerText = fullText;
    return;
  }

  const shortText = fullText.slice(0, limit);
  collectionDescriptionText.innerHTML = `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

  const button = collectionDescriptionText.querySelector('.read-more-btn');
  let isExpanded = false;

  button.addEventListener('click', function () {
    isExpanded = !isExpanded;
    collectionDescriptionText.innerHTML = isExpanded
      ? `${fullText} <button class="read-more-btn active">${window.theme.strings.readLess}</button>`
      : `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

    collectionDescriptionText.querySelector('.read-more-btn').addEventListener('click', arguments.callee);
  });
})();